import { Experimental_CssVarsProvider } from '@mui/material/styles';
import { ReactNode } from 'react';

import { createTheme } from 'src/theme/create-theme';

type Props = {
  children: ReactNode;
};

export const DarkThemeProvider = ({ children }: Props) => {
  const theme = createTheme({ settingsState: { defaultColorScheme: 'dark' } });

  return <Experimental_CssVarsProvider theme={theme} defaultMode='dark' mode='dark'>{children}</Experimental_CssVarsProvider>;
};